<template>
    <div v-if="errors[name]" class="block w-full error-message">
        <p class="text-red-500 py-2 block text-sm">
            {{ errors[name][0] }}
        </p>
    </div>
</template>
<script>
export default {
    props: {
        errors: {
            type: Object,
            default: () => {
            }
        },

        name: {
            type: String,
            required: true
        }
    }
};
</script>
